import { Badge } from '@noor/ui';
import { foodOrderLabel, foodOrderTone } from '../lib/presentation';
export function FoodOrderStatus({ value }: { value?: string | undefined }) {
  return (
    <Badge variant={foodOrderTone(value)}>
      <span aria-hidden="true" className="size-1.5 rounded-full bg-current" />
      {foodOrderLabel(value)}
    </Badge>
  );
}
